import { Box, Chip } from '@mui/material';
import { Close, Check } from '@mui/icons-material';

import * as SHIPMENT_STATUS from 'constants/shipmentStatus';

function Progress(props) {
  const { mediaQuery, classes, shipment, progress, milestone } = props;

  return (
    <Box p={mediaQuery.isMobile ? 2 : 4.5} pb={mediaQuery.isMobile ? 3 : undefined} sx={classes.statusContainer} borderRadius="10px 10px 0 0">
      <Box mb={2.5} sx={classes.statusTitle}>
        <Box>
          <Box component="span" sx={classes.statusText}>
            Status:{' '}
          </Box>
          <Box component="span" sx={classes.statusTextBig} data-testid="progress-status">
            {milestone}
          </Box>
        </Box>
        <Box>{shipment.attempt_count > 1 && <Chip size="small" sx={classes.reattemptButton} label={'2nd attempt'} />}</Box>
      </Box>
      <Box
        sx={{
          ...classes.statusProgress,
          ...(progress[milestone]?.progressBarBackgroundColor && { backgroundColor: progress[milestone].progressBarBackgroundColor }),
        }}
        borderRadius="11px"
      >
        <Box sx={{ ...classes.statusIndicator, ...classes.statusInProgress, ...(progress[milestone] || {}) }}>
          {SHIPMENT_STATUS.FAILED_MILESTONE.indexOf(milestone) > -1 ? (
            <Close sx={classes.whiteIcon} fontSize="small" />
          ) : (
            <Check sx={classes.whiteIcon} />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default Progress;
